import { Icon, type IconName } from "@omnabase/ui";
import type { Me } from "@omnabase/shared";
import { useNav } from "../../lib/nav";
import { AdminShell } from "./AdminShell";
import { ADMIN_MORE } from "./adminTabs";

/** /admin/more (M11 round three): the admin area's phone tab bar keeps the kit's rule of at most five tabs, so the pages that do not fit
 *  (and the way back to the app) are listed here, as the workspace's More screen lists its own. Wider screens have them on the rail. */
export function AdminMore({ me }: { me: Me }) {
  const nav = useNav();
  const rows: { id: string; label: string; icon: IconName; to: string }[] = [...ADMIN_MORE, { id: "back", label: "Back to the app", icon: "back", to: me.workspaces[0] ? `/${me.workspaces[0].slug}` : "/" }];
  return (
    <AdminShell me={me} crumbs={[{ label: "Admin", href: "/admin" }, { label: "More" }]}>
      <main className="ob-more" aria-label="More">
        <nav className="ob-views ob-more__list" aria-label="More">
          {/* the mobile polish round (2026-10-27): the rows in their card box, as every group's (a group without a heading is a bare card) */}
          <div className="ob-views__group"><div className="ob-views__rows">
            {rows.map((r) => <a key={r.id} className="ob-views__item" href={r.to} onClick={(e) => nav(r.to, e)}><Icon name={r.icon} size="sm" /><span className="ob-views__text">{r.label}</span><Icon name="chevronRight" size="sm" className="ob-more__go" /></a>)}
          </div></div>
        </nav>
      </main>
    </AdminShell>
  );
}
